import { render, staticRenderFns } from "./TravelQuotePosted.vue?vue&type=template&id=a155df28&"
import script from "./TravelQuotePosted.vue?vue&type=script&lang=js&"
export * from "./TravelQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./TravelQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelQuotePosted.vue"
export default component.exports